module.exports = __webpack_public_path__ + "static/media/vr-kits-bg.08fbd73f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vr-kits-bg.gif
// module id = 1522
// module chunks = 0